import React, {useEffect, useState} from 'react';
import {Autocomplete} from './Autocomplete';
import {useDispatch, useSelector} from 'react-redux';
import {responseSelector, toTitleCase} from '../utils/utils';
import {
  getEmpresasWithPaginationDuck,
  getEmpresasWithPaginationThunk,
} from '../empresas/duck';
import Etiqueta from '../utils/etiquetaObligatorio/Etiqueta';

function EmpresaAutocompleteMulti({token, onSelectEmpresa, label, required}) {
  const dispatch = useDispatch();

  const modelGetEmpresas = useSelector(
    state => state.getEmpresasWithPagination,
  );

  const [selectedEmpresas, setSelectedEmpresas] = useState([]);

  const [empresas, setEmpresas] = useState([]);
  const [empresaNombre, setEmpresaNombre] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const {data, error} = responseSelector(modelGetEmpresas);

    if (error) {
      dispatch(getEmpresasWithPaginationDuck.actions.clear());
      setError('Ocurrio un error al consultar las empresas');
    }

    if (data) {
      if (!data?.items?.length) {
        setError('No se encontraron empresas');
        return;
      }
      setError('');
      setEmpresas(data.items);
      dispatch(getEmpresasWithPaginationDuck.actions.clear());
    }
  }, [modelGetEmpresas]);

  const dispatchGetEmpresas = () => {
    dispatch(
      getEmpresasWithPaginationThunk({
        userToken: token.raw,
        page: 1,
        limit: 100,
        busquedaRapida: empresaNombre,
        contar: 'n',
        esGrupo: 'TODOS',
        esCliente: 'TODOS',
      }),
    );
  };

  const seleccionarEmpresa = empresa => {
    if (selectedEmpresas.some(e => e.idNumerico === empresa.idNumerico)) {
      return;
    }

    setSelectedEmpresas([...selectedEmpresas, empresa]);
    setEmpresaNombre('');
    setError('');
    setEmpresas([]);
    onSelectEmpresa([...selectedEmpresas, empresa]);
  };

  const quitarEmpresa = empresa => {
    const updated = selectedEmpresas.filter(
      e => e.idNumerico !== empresa.idNumerico,
    );
    setSelectedEmpresas(updated);
    onSelectEmpresa(updated);
  };

  return (
    <>
      <div style={{marginBottom: 5}}>
        <b>
          <Etiqueta texto={label} obligatorio={required} />
        </b>
      </div>

      <Autocomplete
        placeholder="Buscar empresa..."
        dispatchGetDataList={dispatchGetEmpresas}
        dataList={empresas}
        error={error}
        setError={setError}
        value={empresaNombre}
        setValue={setEmpresaNombre}
        setDataList={setEmpresas}
        onItemClick={seleccionarEmpresa}
        onLastItemClick={() => console.log('last item clicked')}
        renderItem={empresa => (
          <div style={{minWidth: 150}}>
            <p>{toTitleCase(empresa.nombre)}</p>
          </div>
        )}
      />

      {/* <br /> */}

      {selectedEmpresas.length > 0 && (
        <div style={{marginTop: 10, marginBottom: 10}}>
          <i>Empresas seleccionadas:</i> <br />
          {selectedEmpresas.map(empresa => (
            <span
              key={empresa.idNumerico}
              style={{marginRight: 8, display: 'block'}}>
              {toTitleCase(empresa.nombre)}
              <button
                style={{
                  marginLeft: 4,
                  border: 'none',
                  background: 'transparent',
                  color: 'red',
                  cursor: 'pointer',
                }}
                onClick={() => quitarEmpresa(empresa)}
                title="Eliminar">
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </>
  );
}

export {EmpresaAutocompleteMulti};
